import { render, staticRenderFns } from "./OrderFabricYarnTypeTable.vue?vue&type=template&id=f05de1ac&"
import script from "./OrderFabricYarnTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricYarnTypeTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderFabricYarnTypeTable.vue?vue&type=style&index=0&id=f05de1ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports